import styled from 'styled-components';

interface Props {
  className?: string;
}

const S = {
  Svg: styled.svg`
    position: relative;
  `,
};

export function IconPlay({ className }: Props) {
  return (
    <S.Svg
      className={className}
      width="20"
      height="24"
      viewBox="0 0 20 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M20 12L0 24V0L20 12Z" />
    </S.Svg>
  );
}
